import {
  DateRange,
  defaultDateRangeFilters,
  Option,
  SplitBy,
} from "@intentsify/types";
import { isPopulatedArray } from "@intentsify/utils";
import {
  DateRangeFilter,
  Filter,
  FiltersContainer,
  FiltersContainerItem,
  FiltersContainerItemSize,
  SplitByFilter,
} from "components";
import { useParams } from "react-router-dom";
import { useAtomValue, useSetAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import {
  selectedTrendingTopicsAtom,
  topicsSplitByAtom,
  trendingTopicsDateRangeAtom,
  trendingTopicsOptionsStateAtom,
  trendingTopicsStateSelector,
} from "../../TrendingTopics.state";

const Filters = () => {
  const campaignId = Number(useParams<"campaignId">().campaignId);
  const {
    selectedTopics,
    isLoading,
    topicsOptions,
    selectedSplitBy,
    selectedDateRange,
  } = useAtomValue(trendingTopicsStateSelector);
  const setSelectedTopics = useSetAtom(selectedTrendingTopicsAtom);
  const resetOptions = useResetAtom(trendingTopicsOptionsStateAtom);
  const setSplitBy = useSetAtom(topicsSplitByAtom);
  const setDateRange = useSetAtom(trendingTopicsDateRangeAtom);

  const onSelectedTopicsChange = (options: Array<Option<string>>) => {
    setSelectedTopics({ campaignId, data: options });
  };

  const hasNoOptions = !isPopulatedArray(topicsOptions);
  const items: FiltersContainerItem[] = [
    {
      component: (
        <Filter
          label={"Topics"}
          options={topicsOptions}
          isLoading={isLoading}
          isDisabled={isLoading || hasNoOptions}
          placeholder="Select topics"
          onFilterValuesChange={(options: Option[]) => {
            onSelectedTopicsChange(options as Array<Option<string>>);
          }}
          selected={selectedTopics.data ?? []}
        />
      ),
      size: FiltersContainerItemSize.XL,
    },
    {
      component: (
        <DateRangeFilter<DateRange>
          isLoading={isLoading}
          isDisabled={isLoading}
          dateRange={selectedDateRange}
          options={defaultDateRangeFilters.dateRangeOptions}
          onChange={(value) => {
            resetOptions();
            setDateRange(value);
          }}
        />
      ),
    },
    {
      component: (
        <SplitByFilter<SplitBy>
          onChange={(value) => setSplitBy(value)}
          options={defaultDateRangeFilters.splitByOptions}
          value={selectedSplitBy}
          isLoading={isLoading}
          isDisabled={isLoading || hasNoOptions}
        />
      ),
    },
  ];

  return <FiltersContainer items={items} />;
};

export { Filters };
